<div class="card">
  <div class="card-header bg-primary text-white d-flex justify-content-between">
    <h5 class="mb-0">Promotional Notification History</h5>

    <span class="badge bg-primary"> Total : {{ totalRecords }} </span>
  </div>

  <div class="card-body p-0">
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th>#</th>

          <th>Audience</th>

          <th>Title</th>

          <th>Message</th>

          <th>Image</th>

          <th>Success</th>

          <th>Failed</th>

          <th>Date</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of notifications; let i = index">
          <td>
            {{ (page - 1) * limit + i + 1 }}
          </td>

          <td>
            <span
              class="badge"
              [ngClass]="item.audience == 'DRIVER' ? 'bg-success' : 'bg-info'"
            >
              {{ item.audience }}
            </span>
          </td>

          <td>
            {{ item.title }}
          </td>

          <td>
            {{ item.message }}
          </td>

          <td>
            <img
              *ngIf="item.imageUrl"
              [src]="item.imageUrl"
              class="notification-image"
              (click)="openImage(item.imageUrl)"
            />

            <span *ngIf="!item.imageUrl"> - </span>
          </td>

          <td class="text-success">
            {{ item.successCount }}
          </td>

          <td class="text-danger">
            {{ item.failureCount }}
          </td>

          <td>
            {{ item.createdOn }}
          </td>
        </tr>

        <tr *ngIf="notifications.length == 0">
          <td colspan="8" class="text-center">No Notification Found</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-footer d-flex  align-items-center">
    <button
      class="btn btn-primary btn-sm"
      [disabled]="!hasPreviousPage"
      (click)="changePage(page - 1)"
    >
      Previous
    </button>

    <span> Page {{ page }} of {{ totalPages }} </span>

    <button
      class="btn btn-primary btn-sm"
      [disabled]="!hasNextPage"
      (click)="changePage(page + 1)"
    >
      Next
    </button>
  </div>
</div>

<div class="image-popup-backdrop" *ngIf="selectedImage" (click)="closeImage()">
  <div class="image-popup-card" (click)="$event.stopPropagation()">
    <button type="button" class="close-btn" (click)="closeImage()">
      &times;
    </button>

    <img [src]="selectedImage" class="popup-image" />
  </div>
</div>
